export const TEST_STANDARD_START = 'test-standard/test-standard-start';
export const TEST_STANDARD_SUCCESS = 'test-standard/test-standard-success';
export const TEST_STANDARD_ERROR = 'test-standard/test-standard-error';
export const TEST_STANDARD_CLEAR = 'test-standard/test-standard-clear';
